// VRBB product page — structure and forms.
//
// Everything on the rug product page that is not pricing: the two purchase
// tabs, size-pill ordering, the deep-link price line, the expandable forms and
// their Klaviyo submissions, and the sample add-to-cart.
//
// Pricing lives in calculator-rug.js. This file has no knowledge of it beyond
// watching #vrbb-summary, which the calculator owns.

(function () {
  'use strict';

  var ctx = { title: '', handle: '', url: '' };
  var ctxEl = document.getElementById('vrbb-product-context');
  if (ctxEl) {
    try { ctx = JSON.parse(ctxEl.textContent) || ctx; } catch (e) {}
  }
  function productUrl() { return window.location.origin + (ctx.url || window.location.pathname); }

  // ---------- size pills, smallest to largest ----------
  // Dawn renders option values in whatever order they are saved on the product,
  // which is arbitrary across the catalogue. Sorting here avoids reordering
  // every product by hand. If ANY label in a group fails to parse, that group
  // is left exactly as it is.
  function sizeToInches(part) {
    var m = part.match(/^(\d+)(?:['\u2032](\d+)?["\u2033]?)?$/);
    if (m) return parseInt(m[1], 10) * 12 + (m[2] ? parseInt(m[2], 10) : 0);
    var n = parseFloat(part);
    return isNaN(n) ? null : n * 12;
  }
   // Curly quotes are converted to straight before parsing, matching the
  // dimensions parser. Two catalogue labels are typed with curly marks
  // (2’9”x9’, 3’4”x13’6”); without this they fall through the regex to
  // parseFloat, which reads 2’9” as 24in instead of 33 — a wrong number, not a
  // parse failure, so the group still sorts and nothing looks broken.
  function sizeArea(text) {
    var parts = String(text)
      .toLowerCase()
      .replace(/[\u2018\u2019\u2032]/g, "'")
      .replace(/[\u201c\u201d\u2033]/g, '"')
      .replace(/\s+/g, '')
      .split(/x|\u00d7/);
    if (parts.length !== 2) return null;
    var w = sizeToInches(parts[0]);
    var l = sizeToInches(parts[1]);
    if (w === null || l === null) return null;
    return { w: w, l: l };
  }

  function sortPills() {
    var scope = document.querySelector('.product__info-container');
    if (!scope) return;
    Array.prototype.forEach.call(scope.querySelectorAll('fieldset'), function (group) {
      var inputs = group.querySelectorAll('input[type="radio"]');
      if (inputs.length < 2) return;

      var items = [];
      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        var label = group.querySelector('label[for="' + input.id + '"]') ||
                    (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL' ? input.nextElementSibling : null);
        if (!label) return;
        var parsed = sizeArea(label.textContent);
        if (!parsed) return;
        items.push({ input: input, label: label, w: parsed.w, l: parsed.l });
      }

      // Width first, then length — 3x5, 3x9, 4x6, 6x9. Sorting by area instead
      // would put 3x9 after 4x6 and break the runs of one width.
      items.sort(function (a, b) { return a.w - b.w || a.l - b.l; });
      items.forEach(function (it) {
        group.appendChild(it.input);
        group.appendChild(it.label);
      });
    });
  }

  // ---------- the two purchase tabs ----------
  function initTabs() {
    var tabs = document.getElementById('vrbb-paths');
    if (!tabs || tabs.dataset.vrbbReady === '1') return;

    var info = tabs.closest('.product__info-container');
    if (!info) return;

    var kids = Array.prototype.slice.call(info.children);

    function findIndex(selector) {
      for (var i = 0; i < kids.length; i++) {
        if (kids[i] === tabs) continue;
        if (kids[i].matches && kids[i].matches(selector)) return i;
        if (kids[i].querySelector && kids[i].querySelector(selector)) return i;
      }
      return -1;
    }
    function isHeading(el) {
      return el && el.classList && el.classList.contains('product__text');
    }

    // Nothing in stock: no panels to group and no tab to switch to. Show the
    // banner, retire the old subheading, touch nothing else.
    if (tabs.classList.contains('vrbb-paths--single')) {
      for (var s = 0; s < kids.length; s++) {
        if (kids[s].id === 'vrbb-section-2' || (kids[s].querySelector && kids[s].querySelector('#vrbb-section-2'))) {
          if (isHeading(kids[s - 1])) kids[s - 1].classList.add('vrbb-was-heading');
          break;
        }
      }
      tabs.dataset.vrbbReady = '1';
      tabs.hidden = false;
      return;
    }

    // Landmarks. Structural, not copy-based.
    var aPicker = findIndex('variant-selects, variant-radios, .product-form__input--pill');
    var aBuy = findIndex('.product-form__buttons');
    var aCalc = findIndex('#vrbb-section-2');
    var aLarger = findIndex('#vrbb-quote-form');

    // Missing anything? Leave the page exactly as it is.
    if (aPicker < 0 || aBuy < 0 || aCalc < 0) return;

    var stockStart = isHeading(kids[aPicker - 1]) ? aPicker - 1 : aPicker;

    // Dawn's buy-buttons render emits div.product-form AND pickup-availability,
    // and share follows both. Absorb every trailing in-stock sibling rather than
    // testing for adjacency, or they end up outside both panels.
    var stockEnd = aBuy;
    for (var n = stockEnd + 1; n < kids.length; n++) {
      if (kids[n].matches('pickup-availability, .product__pickup-availabilities, share-button, .share-button')) {
        stockEnd = n;
      } else {
        break;
      }
    }

    var customStart = isHeading(kids[aCalc - 1]) ? aCalc - 1 : aCalc;
    var customEnd = aLarger > customStart ? aLarger : aCalc;

    if (stockEnd < stockStart || customEnd < customStart || customStart <= stockEnd) return;

    function wrap(from, to, id) {
      var panel = document.createElement('div');
      panel.className = 'vrbb-panel';
      panel.id = id;
      info.insertBefore(panel, kids[from]);
      for (var i = from; i <= to; i++) panel.appendChild(kids[i]);
      return panel;
    }

    var customPanel = wrap(customStart, customEnd, 'vrbb-panel-custom');
    var stockPanel = wrap(stockStart, stockEnd, 'vrbb-panel-stock');

    // The tab labels carry the lead times, so the old headings are redundant.
    [stockPanel, customPanel].forEach(function (panel) {
      var h = panel.firstElementChild;
      if (isHeading(h)) h.classList.add('vrbb-was-heading');
    });

    // Only the divider stranded BETWEEN the two panels. Any other divider on the
    // page — the one above the sample section — is left alone.
    for (var gap = stockPanel.nextElementSibling; gap && gap !== customPanel; gap = gap.nextElementSibling) {
      if (gap.tagName === 'HR' || (gap.children.length === 1 && gap.querySelector('hr'))) {
        gap.style.display = 'none';
      }
    }

    info.insertBefore(tabs, stockPanel);

    var stockBtn = document.getElementById('vrbb-path-stock');
    var customBtn = document.getElementById('vrbb-path-custom');

    function select(which) {
      var stock = which === 'stock';
      stockPanel.hidden = !stock;
      customPanel.hidden = stock;
      stockBtn.classList.toggle('is-active', stock);
      customBtn.classList.toggle('is-active', !stock);
      stockBtn.setAttribute('aria-pressed', stock ? 'true' : 'false');
      customBtn.setAttribute('aria-pressed', stock ? 'false' : 'true');
    }

    stockBtn.addEventListener('click', function () { select('stock'); });
    customBtn.addEventListener('click', function () { select('custom'); });

    // Arrived on a size that isn't on the shelf. Move Dawn's selection onto the
    // first stocked size BEFORE the panel is hidden, so Ready to ship can never
    // hold a live Add to cart for a 12-16 week rug, then open Made to order.
    var oosDeepLink = tabs.dataset.vrbbOosSelected === '1';
    if (oosDeepLink) {
      var pills = stockPanel.querySelectorAll('.product-form__input--pill input[type="radio"]');
      for (var p = 0; p < pills.length; p++) {
        if (window.getComputedStyle(pills[p]).display !== 'none') {
          if (!pills[p].checked) pills[p].click();
          break;
        }
      }
    }

    select(oosDeepLink ? 'custom' : 'stock');

    tabs.dataset.vrbbReady = '1';
    tabs.hidden = false;
  }

  // ---------- deep-link price line ----------
  // The line describes the size in the URL; the calculator describes the size
  // the shopper typed. It goes the moment those can disagree — when the
  // calculator's summary appears, or on a Common sizes prefill. It does not
  // return: from then on the calculator is the only source of truth.
  function initDeeplink() {
    var line = document.querySelector('.vrbb-deeplink');
    if (!line) return;

    var gone = false;
    var obs = null;

    function drop() {
      if (gone) return;
      gone = true;
      if (obs) obs.disconnect();
      document.removeEventListener('click', onClick, true);
      if (line.parentNode) line.parentNode.removeChild(line);
    }
    function onClick(e) {
      if (!e.isTrusted) return;
      if (e.target && e.target.closest && e.target.closest('.vrbb-shortcut')) drop();
    }

    document.addEventListener('click', onClick, true);

    var summary = document.getElementById('vrbb-summary');
    if (summary) {
      if (!summary.hidden) { drop(); return; }
      obs = new MutationObserver(function () { if (!summary.hidden) drop(); });
      obs.observe(summary, { attributes: true, attributeFilter: ['hidden'] });
    }
  }

  // ---------- sample heading ----------
  // The heading is a separate text block, so it survives when the sample
  // section does not render. Keyed off the section's presence, not its copy.
  function hideOrphanSampleHeading() {
    if (document.getElementById('vrbb-section-3')) return;
    var section2 = document.getElementById('vrbb-section-2');
    var headings = document.querySelectorAll('.product__text.inline-richtext.subtitle');
    Array.prototype.forEach.call(headings, function (h) {
      if (section2 && h.compareDocumentPosition(section2) & Node.DOCUMENT_POSITION_PRECEDING) {
        h.classList.add('vrbb-was-heading');
      }
    });
  }

  // ---------- expandables: only one open at a time ----------
  function initExpandables() {
    var triggers = document.querySelectorAll('.vrbb-expandable-trigger');
    Array.prototype.forEach.call(triggers, function (trigger) {
      var target = document.getElementById(trigger.dataset.target);
      if (!target) return;

      trigger.addEventListener('click', function () {
        var opening = target.hidden;

        Array.prototype.forEach.call(triggers, function (other) {
          if (other === trigger) return;
          var otherTarget = document.getElementById(other.dataset.target);
          if (otherTarget && !otherTarget.hidden) {
            otherTarget.hidden = true;
            other.setAttribute('aria-expanded', 'false');
            other.classList.remove('vrbb-open');
          }
        });

        target.hidden = !opening;
        trigger.setAttribute('aria-expanded', opening ? 'true' : 'false');
        trigger.classList.toggle('vrbb-open', opening);
      });
    });
  }

  // ---------- Klaviyo forms ----------
  // Both product forms identify the profile, then fire a metric. Klaviyo flows
  // do the emailing. If klaviyo.js has not loaded the form says so rather than
  // failing silently.
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function val(id) {
    var el = document.getElementById(id);
    return el && el.value ? el.value.trim() : '';
  }
  function num(id) {
    var v = val(id);
    return v === '' ? 0 : parseInt(v, 10);
  }
  function ftLabel(ft, inch) {
    return inch > 0 ? ft + ' ft ' + inch + ' in' : ft + ' ft';
  }
  function nameParts(name) {
    var space = name.indexOf(' ');
    var out = { first_name: space > 0 ? name.slice(0, space) : name };
    if (space > 0) out.last_name = name.slice(space + 1);
    return out;
  }
  function settled(maybePromise, onOk, onErr) {
    if (maybePromise && typeof maybePromise.then === 'function') maybePromise.then(onOk).catch(onErr);
    else onOk();
  }

  function initKlaviyoForm(cfg) {
    var form = document.getElementById(cfg.form);
    if (!form) return;

    var done = document.getElementById(cfg.done);
    var err = document.getElementById(cfg.error);
    var btn = document.getElementById(cfg.button);
    var label = btn ? btn.textContent : '';

    function fail() {
      if (err) err.style.display = '';
      if (btn) { btn.disabled = false; btn.textContent = label; }
    }
    function succeed() {
      form.style.display = 'none';
      if (done) done.style.display = '';
    }

    if (cfg.beforeInit) cfg.beforeInit(form);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (err) err.style.display = 'none';
      if (!form.checkValidity()) { form.reportValidity(); return; }

      // Browsers accept "a@b". Require a real domain.
      var emailEl = document.getElementById(cfg.email);
      if (!EMAIL_RE.test(val(cfg.email))) {
        emailEl.setCustomValidity('Please enter a complete email address.');
        emailEl.reportValidity();
        emailEl.setCustomValidity('');
        return;
      }

      var payload = cfg.build(fail);
      if (!payload) return;
      if (!window.klaviyo) { fail(); return; }

      if (btn) { btn.disabled = true; btn.textContent = 'Sending\u2026'; }

      settled(window.klaviyo.identify(payload.identity), function () {
        settled(window.klaviyo.track(cfg.metric, payload.props), succeed, fail);
      }, fail);
    });
  }

  function initLargerSizeForm() {
    initKlaviyoForm({
      form: 'vrbb-quote-fields',
      done: 'vrbb-quote-done',
      error: 'vrbb-quote-error',
      button: 'vrbb-quote-submit',
      email: 'vrbb-quote-email',
      metric: 'Requested Custom Rug Size',

      beforeInit: function (form) {
        // Phone: digits and the usual dialling punctuation only.
        var phoneEl = document.getElementById('vrbb-quote-phone');
        if (phoneEl) {
          phoneEl.addEventListener('input', function () {
            var cleaned = phoneEl.value.replace(/[^0-9+()\-. ]/g, '');
            if (cleaned !== phoneEl.value) phoneEl.value = cleaned;
          });
        }
        Array.prototype.forEach.call(form.querySelectorAll('.vrbb-dim-input'), function (inp) {
          inp.addEventListener('input', function () {
            var v = inp.value.replace(/[^0-9]/g, '');
            if (v === '') { inp.value = ''; return; }
            var n = parseInt(v, 10);
            var mn = inp.min !== '' ? parseInt(inp.min, 10) : null;
            var mx = inp.max !== '' ? parseInt(inp.max, 10) : null;
            if (mx !== null && n > mx) n = mx;
            if (mn !== null && n < mn) n = mn;
            inp.value = n;
          });
        });
      },

      build: function (fail) {
        var phoneEl = document.getElementById('vrbb-quote-phone');
        var phoneVal = val('vrbb-quote-phone');
        // Optional, but if given it needs enough digits to dial.
        if (phoneVal && phoneVal.replace(/\D/g, '').length < 10) {
          phoneEl.setCustomValidity('Please enter a complete phone number, or leave it blank.');
          phoneEl.reportValidity();
          phoneEl.setCustomValidity('');
          return null;
        }

        var name = val('vrbb-quote-name');
        var wFt = num('vrbb-quote-width-ft'), wIn = num('vrbb-quote-width-in');
        var lFt = num('vrbb-quote-length-ft'), lIn = num('vrbb-quote-length-in');
        var wTotal = wFt * 12 + wIn;
        var lTotal = lFt * 12 + lIn;

        // A rug's width is its shorter side. Someone thinking about their room
        // may enter 20 x 3 meaning a runner. Swap silently rather than stopping
        // them, and keep what they typed in the event so nothing is lost.
        var swapped = false;
        if (wTotal > lTotal) {
          swapped = true;
          var tFt = wFt, tIn = wIn, tTotal = wTotal;
          wFt = lFt; wIn = lIn; wTotal = lTotal;
          lFt = tFt; lIn = tIn; lTotal = tTotal;
        }

        var identity = nameParts(name);
        identity.email = val('vrbb-quote-email');
        if (phoneVal) identity.phone_number = phoneVal;

        return {
          identity: identity,
          props: {
            Rug: ctx.title,
            RugHandle: ctx.handle,
            RugURL: productUrl(),
            Width: ftLabel(wFt, wIn),
            Length: ftLabel(lFt, lIn),
            Size: ftLabel(wFt, wIn) + ' x ' + ftLabel(lFt, lIn),
            WidthInches: wTotal,
            LengthInches: lTotal,
            EnteredAsWidthFirst: swapped ? ftLabel(lFt, lIn) + ' x ' + ftLabel(wFt, wIn) : null,
            Room: val('vrbb-quote-room'),
            InteriorDesigner: document.getElementById('vrbb-quote-designer').checked,
            Name: name,
            Email: val('vrbb-quote-email'),
            Phone: phoneVal
          }
        };
      }
    });
  }

  function initQuestionForm() {
    initKlaviyoForm({
      form: 'vrbb-question-fields',
      done: 'vrbb-question-done',
      error: 'vrbb-question-error',
      button: 'vrbb-question-submit',
      email: 'vrbb-question-email',
      metric: 'Asked A Rug Question',

      build: function () {
        var name = val('vrbb-question-name');
        var identity = nameParts(name);
        identity.email = val('vrbb-question-email');

        return {
          identity: identity,
          props: {
            Rug: ctx.title,
            RugHandle: ctx.handle,
            RugURL: productUrl(),
            Question: val('vrbb-question-text'),
            Name: name,
            Email: val('vrbb-question-email')
          }
        };
      }
    });
  }

  // ---------- sample add to cart ----------
  function initSample() {
    var btn = document.getElementById('vrbb-s3-atc');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var id = btn.dataset.variantId;
      if (!id) return;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function (err) {
          btn.disabled = false;
          console.error('VRBB sample add-to-cart failed:', err);
        });
    });
  }

  // ---------- boot ----------
  function boot() {
    sortPills();
    initTabs();
  }

  function bootOnce() {
    boot();
    hideOrphanSampleHeading();
    initDeeplink();
    initExpandables();
    initLargerSizeForm();
    initQuestionForm();
    initSample();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootOnce);
  } else {
    bootOnce();
  }

  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 0); });

  // Dawn re-renders the picker after a variant change, restoring the saved order.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio') setTimeout(sortPills, 0);
  });
})();
